import React from 'react';
import { Facebook } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-[#050B15] text-slate-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10 pt-16 pb-8">
        <div className="grid gap-10 sm:grid-cols-2 lg:grid-cols-3">
          <div>
            <div className="flex items-center gap-3">
              <div className="w-11 h-11 rounded-lg bg-[#F59E0B] flex items-center justify-center">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" className="w-6 h-6 text-slate-900">
                  <path d="M6 20V10"/>
                  <path d="M6 10c0-3 2-6 6-6s6 3 6 6"/>
                  <path d="M18 10v10"/>
                  <path d="M2 20h20"/>
                  <path d="M9 14h6"/>
                </svg>
              </div>
              <div className="flex flex-col leading-tight">
                <span className="font-extrabold tracking-tight text-[15px] text-white">ACE MONEY EXCHANGE</span>
                <span className="text-[10px] tracking-[0.22em] text-[#F59E0B] font-semibold">MONEY EXCHANGE</span>
              </div>
            </div>
            <p className="mt-6 text-slate-400 max-w-xs leading-relaxed">
              Your trusted partner for currency exchange in Kathmandu. Licensed by Nepal Rastra Bank and serving the Thamel community since 2014.
            </p>

            <address className="mt-6 not-italic text-sm text-slate-400 space-y-1.5">
              <div>Tridevi Sadak, between Gambeshi Dohori Nach Ghar and Columbia clothing store, Thamel, Kathmandu 44600, Nepal</div>
              <div>
                <a href="tel:+97714412345" className="hover:text-[#F59E0B] transition-colors">+977-1-4412345</a>
                {' · '}
                <a href="mailto:info@acemoneyexchange.com.np" className="hover:text-[#F59E0B] transition-colors">info@acemoneyexchange.com.np</a>
              </div>
              <div>Open daily: 8:00 AM – 8:00 PM</div>
            </address>

            <div className="mt-6 flex items-center gap-3">
              {[
                { Icon: Facebook, href: 'https://www.facebook.com/share/178RSLEeNZ/', label: 'Facebook' },
              ].map(({ Icon, href, label }) => (
                <a
                  key={href}
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={label}
                  className="w-10 h-10 rounded-full bg-white/5 hover:bg-[#F59E0B] flex items-center justify-center text-slate-300 hover:text-slate-900 transition-colors"
                >
                  <Icon className="w-4 h-4" />
                </a>
              ))}
            </div>
          </div>

          <div className="md:pl-8">
            <h4 className="font-bold text-white">Quick Links</h4>
            <ul className="mt-5 space-y-3 text-slate-400">
              {[
                { label: 'Exchange Rates', href: '#home' },
                { label: 'Our Services', href: '#services' },
                { label: 'About Us', href: '#about' },
                { label: 'Contact', href: '#contact' },
              ].map(({ label, href }) => (
                <li key={label}><a href={href} className="hover:text-[#F59E0B] transition-colors">{label}</a></li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-bold text-white">Resources</h4>
            <ul className="mt-5 space-y-3 text-slate-400">
              {[
                { label: 'Nepal Rastra Bank', href: 'https://www.nrb.org.np/', external: true },
                { label: 'Get Directions', href: 'https://www.google.com/maps/place/Ace+Money+Exchange/@27.7144098,85.3132012,19.29z/data=!4m14!1m7!3m6!1s0x39eb1910506ec767:0xa5e4e2ace7bd200a!2sAce+Money+Exchange!8m2!3d27.7142048!4d85.313599!16s%2Fg%2F11zf605rkh!3m5!1s0x39eb1910506ec767:0xa5e4e2ace7bd200a!8m2!3d27.7142048!4d85.313599!16s%2Fg%2F11zf605rkh', external: true },
                { label: 'Sitemap', href: '/sitemap.xml', external: true },
              ].map(({ label, href, external }) => (
                <li key={label}>
                  <a
                    href={href}
                    target={external ? '_blank' : undefined}
                    rel={external ? 'noopener noreferrer' : undefined}
                    className="hover:text-[#F59E0B] transition-colors"
                  >
                    {label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-white/10 flex flex-col sm:flex-row justify-between items-center gap-3 text-center sm:text-left">
          <div className="text-slate-500 text-sm">© 2014–2026 Ace Money Exchange Pvt. Ltd. All Rights Reserved.</div>
          <div className="flex items-center gap-6 text-sm text-slate-500">
            <a href="#" className="hover:text-[#F59E0B]">Privacy Policy</a>
            <a href="#" className="hover:text-[#F59E0B]">Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
